<template>
  
      <div class="row wrap pointer click center" >
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="13.0055" cy="13.0003" r="10.4" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13 26C20.1799 26 26 20.1799 26 13C26 5.8201 20.1799 0 13 0C5.8201 0 0 5.8201 0 13C0 20.1799 5.8201 26 13 26ZM13.0065 7.4854C12.7628 7.72919 12.6259 8.05979 12.6259 8.4045C12.6259 8.74921 12.7628 9.07981 13.0065 9.3236L15.3829 11.7H7.4841C7.13932 11.7 6.80866 11.837 6.56486 12.0808C6.32106 12.3246 6.1841 12.6552 6.1841 13C6.1841 13.3448 6.32106 13.6754 6.56486 13.9192C6.80866 14.163 7.13932 14.3 7.4841 14.3H15.3829L13.0065 16.6777C12.7697 16.9229 12.6387 17.2513 12.6416 17.5921C12.6446 17.933 12.7813 18.259 13.0223 18.5001C13.2634 18.7411 13.5894 18.8778 13.9303 18.8808C14.2711 18.8837 14.5995 18.7527 14.8447 18.5159L19.4402 13.9191C19.6839 13.6753 19.8208 13.3447 19.8208 13C19.8208 12.6553 19.6839 12.3247 19.4402 12.0809L14.846 7.4854C14.6022 7.24169 14.2716 7.10478 13.9269 7.10478C13.5822 7.10478 13.2503 7.24169 13.0065 7.4854Z" fill="#427EFF"/></svg>
      </div>

</template>
<script setup>
</script>
<script>
/* eslint-disable */
import { defineComponent } from 'vue';
export default defineComponent({
  mounted() {      
  //  
  },  
  props:{
    disable: Boolean,    
  },
  data() {
    return {    
     

    }
  },
  methods:{
    // 
  },
 
});

</script>
<style scoped>
.container{
   width: 380px; 
   height: 100%; 
   border-radius: 20px; 
   background-color: var(--g05);   
}
.messageBox{
  position: relative; 
  align-self: flex-end; 
  overflow-y: scroll; 
  width: 380px; 
  height: 100%; 
  transform: scale(1,-1); 
}
.messageList{
  padding: 15px; 
  padding-bottom: 60px; 
  transform: scale(1,1);
}
</style>